export const links = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://ftm-swap.hyperjump.fi',
      },
      {
        label: 'Liquidity',
        href: 'https://ftm-swap.hyperjump.fi/#/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    href: '/syrup',
  },
  {
    label: 'Lottery',
    icon: 'TicketIcon',
    href: '/lottery',
  },
  {
    label: 'NFT',
    icon: 'NftIcon',
    href: '/nft',
  },
  {
    label: 'Profile & Teams',
    icon: 'GroupsIcon',
    items: [
      {
        label: 'Leaderboard',
        href: '/',
      },
      {
        label: 'YourProfile',
        href: '/',
      },
    ],
    calloutClass: 'rainbow',
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    items: [
      {
        label: 'Overview',
        href: 'https://ftm-info.hyperjump.fi',
      },
      {
        label: 'Tokens',
        href: 'https://ftm-info.hyperjump.fi/tokens',
      },
      {
        label: 'Pairs',
        href: 'https://ftm-info.hyperjump.fi/pairs',
      },
      {
        label: 'Accounts',
        href: 'https://ftm-info.hyperjump.fi/accounts',
      },
    ],
  },
  {
    label: 'IFO',
    icon: 'IfoIcon',
    items: [
      {
        label: 'Next',
        href: '/ifo',
      },
      {
        label: 'History',
        href: '/ifo/history',
      },
    ],
  },
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: 'Voting',
        href: 'https://voting.hyperjump.fi',
      },
      {
        label: 'Github',
        href: 'https://github.com/HyperJump-DeFi',
      },
      {
        label: 'Docs',
        href: 'https://docs.hyperjump.fi',
      },
    ],
  },
]

export const socials = [
  {
    label: 'Discord',
    icon: 'DiscordIcon',
    href: 'https://discord.com/invite/PDHCV6rWru',
  },
  {
    label: 'Telegram',
    icon: 'TelegramIcon',
    href: 'https://t.me/hyperjumpbsc',
  },
  {
    label: 'Twitter',
    icon: 'TwitterIcon',
    href: 'https://twitter.com/HyperJumpBSC',
  },
]

export const MENU_HEIGHT = 80
export const MENU_HEIGHT_MOBILE = 120
export const MENU_ENTRY_HEIGHT = 48
export const SIDEBAR_WIDTH_FULL = 240
export const SIDEBAR_WIDTH_REDUCED = 56
